export const CREATE_MOUSEOVER_TEXT = 'CREATE_MOUSEOVER_TEXT';
export const GET_MOUSEOVER_TEXT = 'GET_MOUSEOVER_TEXT';
export const UPDATE_MOUSEOVER_TEXT = 'UPDATE_MOUSEOVER_TEXT';
